import InfoOptionsFormComponent from '../../components/info-options/InfoOptionsFormComponent'

export default function InfoOptionsBloc() {

      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Options supplémentaires :</h2>
            <p className="text m-y-sm ">Nous vous proposons des options supplémentaire afin de mieux vous protéger. Cette étape n'est pas obligatoire. </p>
            <InfoOptionsFormComponent />
          </div>
        </div>
      )
}